var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"ani-slide-in"}},[(!_vm.$auth.loading && !_vm.$workSessions.loading)?_c(_vm.activeComponent,{tag:"component"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }